import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import { styles } from './styles'
const useStyles = makeStyles(() => styles)

export const CardWrapper = ({ children, isClickable, href }) => {
  const classes = useStyles()
  return isClickable ? (
    <Link
      to={href || ''}
      onClick={event => {
        event.stopPropagation()
      }}
      className={classes.link}
    >
      {children}
    </Link>
  ) : (
    children
  )
}
